import React, { createContext, useContext, useState, useEffect } from "react";
import { GetOwnerDetailsFromToken,fetchUserDetailsByUserId } from '../../Services/userService.js';
import { GetUserDetailsFromToken } from '../../Services/employeeService.jsx';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userDetails, setUserDetails] = useState(null);
    const [empDetails, setEmpDetails] = useState(null);
    const [userId, setuserId]  = useState();
    const [initial, setInitials] = useState();
    const [loader, setLoader] = useState(true);
    useEffect(() => {
        const fetchEmployeeData = async () => {
            try {
                const userData = await GetUserDetailsFromToken();
                if(userData?.companyEmail){
                    setEmpDetails(userData);
                    //setInternalEmployeeEmail(userData.companyEmail );  // Set fetched data
                    const initials = getInitials(userData.name);
                    setInitials(initials);
                    setLoader(false);
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchEmployeeData(); 
    }, []); 
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                // conditionally call getownerdetails from token based on loggedin person 
                const userData = await GetOwnerDetailsFromToken();
                setuserId(userData.userId)
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchUserData(); 
    }, []); 
    function getInitials(fullName) {
        if (!fullName) return '';
      
        const nameParts = fullName.trim().split(' ');
        return nameParts
          .map(part => part[0].toUpperCase())
          .join('');
      }
    useEffect(() => {
        const fetchOwnerData = async () => {
            if (!userId) return;  // Ensure userId is available before making API call  
            try {
                const userData = await fetchUserDetailsByUserId(userId);
                setUserDetails(userData);
                const fullName = `${userData?.firstName} ${userData?.lastName}`;
                const initials = getInitials(fullName);
                setInitials(initials);
                setLoader(false);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };
    
        fetchOwnerData();
    }, [userId]);  // Runs only when userId changes and is not null

    return (
        <UserContext.Provider value={{ userDetails,empDetails, initial,loader }}>
            {children}
        </UserContext.Provider>
    );
};

// Custom Hook to Use UserContext
export const useUser = () => useContext(UserContext);
